import {ClientFilterProperties} from "./client-filter-properties";
import {Organization} from "../../../models/organization";

export class ClientFilter {
  public readonly id: number;
  public readonly name: string;
  public readonly properties: ClientFilterProperties[];
  public readonly sorters: { property: string, direction: string }[];
  public readonly limit: number;
  public readonly user: any;
  public readonly organizations: Partial<Organization>[];

  constructor(id: number, name: string, properties: ClientFilterProperties[], sorters: { property: string, direction: string }[], limit: number, user: any, organizations: Partial<Organization>[]) {
    Object.assign(this, {id, name, properties, sorters, limit, user, organizations});
  }
}
